

























/*
    * Method for pupulate text input control - STARTS
    1.  columns                 - For arrange the add/edit form layout. Possible Views( multiCoumn 1 to 4)
    2.  create                  - A boolean value that indicates whether this field is shown in the create record form. Default value is true.
    3.  disabled                - For create a disabled input field. Tab index 'll be -1 for this field.
    4.  edit                    - A boolean value that indicates whether this field is shown in the edit record form. Default value is true.
    5.  fieldName               - Name of the field.
    6.  formCreate              - Used to find the current operation of the popup field control.
    7.  hint                    - The hint property on text fields adds the provided string beneath the text field.
    8.  parentName              - Used to find the component name.
    9.  record                  - Object of the field.
    10. showInputs              - This is using for internal purpose, to check whether all the inputs are binded.
    11. title                   - A string that is shown on top of the table. This is optional.
    12. newLine                 - Spacer add in new line
    13. underline               - with or without bottom border
*/
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";

/*
    * Component's properties and events
*/
@Component({})

export default class SpacerComponent extends Vue   {
    /*
        * Component's props
    */
     @Prop() readonly columns!: string;
     @Prop() readonly create!: string;
     @Prop() readonly disabled!: string;
     @Prop() readonly edit!: string;
     @Prop() readonly fieldName!: string;
     @Prop() readonly formCreate!: string;
     @Prop() readonly hint!: string;
     @Prop() readonly parentName!: string;
     @Prop() readonly record!: string;
     @Prop() readonly showInputs!: string;
     @Prop() readonly title!: string;
     @Prop() readonly newLine!: string;
     @Prop() readonly underline!: string;
}
